import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-case',
  imports: [CommonModule, MatCardModule, MatButtonModule],
  templateUrl: './case.component.html',
  styleUrl: './case.component.scss',
})
export class CaseComponent {
  caseId!: string | null;

  email = 'accom@cisassist.com.au';

  constructor(
    private route: ActivatedRoute,

    private router: Router
  ) {}
  showSuccess = false;

  ngOnInit() {
    this.caseId = this.route.snapshot.paramMap.get('id');
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as { success?: boolean };

    this.showSuccess = !!state?.success;
  }
  goBack() {
    this.router.navigate(['/']);
  }
}
